import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=48a40972&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"
import style0 from "./TableList.vue?vue&type=style&index=0&id=48a40972&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a40972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a40972')) {
      api.createRecord('48a40972', component.options)
    } else {
      api.reload('48a40972', component.options)
    }
    module.hot.accept("./TableList.vue?vue&type=template&id=48a40972&scoped=true", function () {
      api.rerender('48a40972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/table/TableList.vue"
export default component.exports